import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { MessageView } from '@/components/ui/MessageView';
import type { IMediaItem, IMediaPickerProps, IMediaShareContext } from '@/models/Media';
import { mediaRegistry } from '@/services/media/registry';
import {
  KEYBOARD_OPEN_SNAP_POINT,
  type IContextSheetContentProps,
  type ISheetConfig,
} from '@/components/ui/ContextSheet';

interface IGifPickerSheetProps extends IContextSheetContentProps {
  payload?: {
    onSelect: (item: IMediaItem, ctx?: IMediaShareContext) => void;
  };
}

export function GifPickerSheet({ payload, onClose }: IGifPickerSheetProps) {
  const { t } = useTranslation();
  const provider = mediaRegistry.defaultFor('gif');

  if (!provider) {
    return (
      <View className="flex-1 items-center justify-center px-6">
        <MessageView type="warning" text={t('media.failed_to_load')} disableHeight />
      </View>
    );
  }

  const PickerComponent = provider.PickerComponent;
  const pickerProps: IMediaPickerProps = {
    type: 'gif',
    displayName: provider.displayName,
    onSelect: (item, ctx) => payload?.onSelect(item, ctx),
    onClose: onClose ?? (() => undefined),
  };

  return <PickerComponent {...pickerProps} />;
}

GifPickerSheet.sheetConfig = {
  height: 'xl',
  snapPoints: [KEYBOARD_OPEN_SNAP_POINT],
  scrollableContent: true,
  integratedNativeSheetScrollGestures: true,
  adjustForWebKeyboard: true,
  hideCloseButton: true,
  flushBottom: true,
} satisfies ISheetConfig;
